import React from 'react';
import StyledVoiceAudioWaves from './StyledVoiceAudioWaves';

interface VoiceAudioWavesProps {
  isPlaying: boolean;
}

const VoiceAudioWaves: React.FC<VoiceAudioWavesProps> = ({ isPlaying }) => {
  return (
    <StyledVoiceAudioWaves isPlaying={isPlaying}>
      <div className="bar"></div>
      <div className="bar"></div>
      <div className="bar"></div>
      <div className="bar"></div>
      <div className="bar"></div>
    </StyledVoiceAudioWaves>
  );
};

export default VoiceAudioWaves;
